import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy, X, ArrowRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export const AwardsBanner = () => {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [dismissed, setDismissed] = useState(sessionStorage.getItem('awards_banner_dismissed') === '1');

  useEffect(() => {
    fetch(`${API}/api/awards/config`)
      .then(r => r.json())
      .then(d => d.success && setConfig(d.config))
      .catch(() => {});
  }, []);

  if (dismissed || !config) return null;
  if (!['nominations_open', 'voting_open'].includes(config.status)) return null;

  const fmt = (iso) => {
    const d = new Date(iso + 'T00:00:00');
    return isNaN(d) ? iso : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const isVoting = config.status === 'voting_open';
  const msg = isVoting
    ? <>Voting is live until <strong>{fmt(config.voting_end_date)}</strong> — support your favorites!</>
    : <>Nominations open until <strong>{fmt(config.nomination_end_date)}</strong></>;

  return (
    <div
      data-testid="awards-banner"
      className="bg-gradient-to-r from-purple-700 via-fuchsia-600 to-pink-600 text-white pl-4 pr-10 sm:px-6 py-2 flex items-center justify-center gap-2 sm:gap-3 text-xs sm:text-sm relative"
    >
      <Trophy className="w-4 h-4 text-yellow-300 shrink-0" />
      <span className="min-w-0">
        <strong className="hidden sm:inline">Global TA Awards {config.year} · </strong>{msg}
      </span>
      <button
        data-testid="awards-banner-cta"
        onClick={() => navigate('/awards')}
        className="bg-yellow-400 text-purple-900 font-bold px-3 sm:px-4 py-1 rounded-full text-xs hover:bg-yellow-300 shrink-0 flex items-center gap-1"
      >
        {isVoting ? 'Vote now' : 'Nominate now'} <ArrowRight className="w-3 h-3" />
      </button>
      <button
        data-testid="awards-banner-dismiss"
        onClick={() => { sessionStorage.setItem('awards_banner_dismissed', '1'); setDismissed(true); }}
        className="absolute right-3 opacity-80 hover:opacity-100"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
